import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { useLocalizeMessage, ModalWindow } from 'libs.nucleus';
import { StepFooter } from '../step_footer';
import { CloneTransferTemplateStep2 } from './clone_transfer_template_step2.component';
import { CloneTransferTemplateStep3 } from './clone_transfer_template_step3.component';
import { CreateTransferTemplateByDataBuilderStep3 } from './create_transfer_template_by_data_builder_step_3.component';
import { CreateTransferTemplateBySqlEditorStep2 } from './create_transfer_template_by_sql_editor_step_2.component';
import { CreateTransferTemplateBySqlEditorStep3 } from './create_transfer_template_by_sql_editor_step_3.component';
import { CreateTransferTemplatePivotStep } from './create_transfer_template_pivot_step.component';
import { CreateTransferTemplateStep1 } from './create_transfer_template_step_1.component';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
import { useStepNavigation } from '../../hooks/use_step_navigation';
export const CreateTransferTemplateModal = ({ onClose }) => {
    const translate = useLocalizeMessage();
    const { templateCreationOption, isCreateFormValid, createDataTransferTemplate, isLoading, resetForm, pivotDataEnabled, } = useContext(DataTransferTemplateContext);
    const totalSteps = useMemo(() => (templateCreationOption === 'sql_editor' && pivotDataEnabled ? 4 : 3), [templateCreationOption, pivotDataEnabled]);
    // Create step validations using the context state
    const stepValidations = useMemo(() => ({
        2: () => isCreateFormValid,
    }), [isCreateFormValid]);
    const { currentStep, isFirstStep, isLastStep, handleNext, handlePrevious } = useStepNavigation({
        totalSteps,
        stepValidations,
    });
    const handleCloseModal = () => {
        resetForm();
        onClose();
    };
    const isCreate = useMemo(() => templateCreationOption === 'sql_editor' || templateCreationOption === 'data_builder', [templateCreationOption]);
    const continueButton = {
        label: translate('Continue'),
        onClick: handleNext,
        disabled: currentStep === 2 && isCreate && (!isCreateFormValid || isLoading),
    };
    const submitButton = {
        label: isCreate ? translate('Create') : translate('Clone'),
        onClick: async () => {
            await createDataTransferTemplate();
            handleCloseModal();
        },
        disabled: isLoading || !isCreateFormValid,
    };
    const footerSecondaryActionButtons = [
        {
            label: translate('Cancel'),
            onClick: handleCloseModal,
        },
    ];
    if (!isFirstStep) {
        footerSecondaryActionButtons.push({
            label: translate('Back'),
            onClick: handlePrevious,
        });
    }
    return (_jsxs(ModalWindow, { title: translate(`Create data transfer template`), isOpen: true, closeWindow: handleCloseModal, footerPrimaryActionButton: isLastStep ? submitButton : continueButton, footerSecondaryActionButtons: footerSecondaryActionButtons, footerCenterContent: _jsx(StepFooter, { currentStep: currentStep, totalSteps: totalSteps }), width: 'full', children: [currentStep === 1 && _jsx(CreateTransferTemplateStep1, {}), currentStep === 2 && templateCreationOption === 'sql_editor' && _jsx(CreateTransferTemplateBySqlEditorStep2, {}), currentStep === 3 && templateCreationOption === 'sql_editor' && _jsx(CreateTransferTemplateBySqlEditorStep3, {}), currentStep === 4 && templateCreationOption === 'sql_editor' && pivotDataEnabled && (_jsx(CreateTransferTemplatePivotStep, {})), currentStep === 2 && templateCreationOption === 'data_builder' && _jsx(CreateTransferTemplateBySqlEditorStep2, {}), currentStep === 3 && templateCreationOption === 'data_builder' && _jsx(CreateTransferTemplateByDataBuilderStep3, {}), currentStep === 2 && templateCreationOption === 'clone' && _jsx(CloneTransferTemplateStep2, {}), currentStep === 3 && templateCreationOption === 'clone' && _jsx(CloneTransferTemplateStep3, {})] }));
};
